import "./Widget.scss";
import { FaShareAlt, FaFacebookF } from "react-icons/fa";
import { ImGooglePlus } from "react-icons/im";
import { TfiYoutube } from "react-icons/tfi";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaTelegram } from "react-icons/fa";
import { Link } from "react-router-dom";
export const Widget = ({ adsMain }) => {
  return (
    <div className="widget">
      <div className="top">
        {adsMain.map((ads) => {
          return (
            <Link to={ads.link} target="_blank">
              <img src={ads.image} alt="Advertisement" />
            </Link>
          );
        })}
      </div>
      <div className="center">
        <h2>Stay Connected</h2>
        <FaShareAlt className="icon" />
      </div>

      <div className="bottom">
        <ul className="nav">
          <li className="facebook">
            <Link>
              <span className="icon">
                <FaFacebookF className="facebookicon" size={25} />
              </span>
              {/* <span className="count">513</span>
              <span className="title">Likes</span> */}
            </Link>
          </li>

          <li className="whatsapp">
            <Link>
              <span className="icon">
                <IoLogoWhatsapp className="whatsappicon" size={25} />
              </span>
              {/* <span className="count">3297</span>
              <span className="title">Followers</span> */}
            </Link>
          </li>

          <li className="googlePlus">
            <Link>
              <span className="icon">
                <ImGooglePlus className="googleicon" size={25} />
              </span>
              {/* <span className="count">596282</span>
              <span className="title">Followers</span> */}
            </Link>
          </li>

          <li className="youtube">
            <Link>
              <span className="icon">
                <TfiYoutube className="youtubeicon" size={25} />
              </span>
              {/* <span className="count">596282</span>
              <span className="title">Subscriber</span> */}
            </Link>
          </li>
          <li className="telegram">
            <Link>
              <span className="icon">
                <FaTelegram className="telegramicon" size={25} />
              </span>
              {/* <span className="count">596282</span>
              <span className="title">Subscriber</span> */}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
